// This file was auto-generated by @insertish/oapi!
export const defaultBaseURL = "https://mutinyapp.gg/api";
